import { TextBox } from "./text-box";

export class PhoneBox extends TextBox {
    public getComponentName(): string {
        return "PhoneBoxComponent";
    }
}
